import {
  makePaginationState,
  makeOffesetPaginationState,
  makeListState,
  convertListToPagination,
  STATUSES,
} from 'app/utils/redux';

import * as t from './types';

const initialState = {
  searchedQuery: null,
  searchStories: makeOffesetPaginationState(),
  searchTags: makeOffesetPaginationState(),
  searchUsers: makeOffesetPaginationState(),
  recommendations: makeOffesetPaginationState(),
  tagRanking: makeListState(),
  popularTags: makePaginationState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch stories
    case `${t.FETCH_ES_SEARCH_ALL}_PENDING`:
      return {
        ...state,
        searchStories: {
          ...state.searchStories,
          status: STATUSES.PENDING,
        },
        searchTags: {
          ...state.searchTags,
          status: STATUSES.PENDING,
        },
        searchUsers: {
          ...state.searchUsers,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_ES_SEARCH_ALL}_SUCCESS`: {
      if (Object.keys(action.payload.result).length === 0) {
        return {
          ...state,
          searchedQuery: null,
          searchStories: {
            status: STATUSES.SUCCESS,
            isLoaded: true,
            pagination: {
              count: 0,
              items: [],
            },
          },
          searchTags: {
            status: STATUSES.SUCCESS,
            isLoaded: true,
            pagination: {
              count: 0,
              items: [],
            },
          },
          searchUsers: {
            status: STATUSES.SUCCESS,
            isLoaded: true,
            pagination: {
              count: 0,
              items: [],
            },
          },
        };
      }

      return {
        ...state,
        searchedQuery: action.meta.q,
        searchStories: {
          ...state.searchStories,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result.stories,
            items: action.payload.result.stories.items,
          },
        },
        searchTags: {
          ...state.searchTags,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result.tags,
            items: action.payload.result.tags.items,
          },
        },
        searchUsers: {
          ...state.searchUsers,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result.users,
            items: action.payload.result.users.items,
          },
        },
      };
    }

    case `${t.FETCH_ES_SEARCH_ALL}_ERROR`:
      return {
        ...state,
        searchStories: {
          ...state.searchStories,
          status: STATUSES.ERROR,
        },
        searchTags: {
          ...state.searchTags,
          status: STATUSES.ERROR,
        },
        searchUsers: {
          ...state.searchUsers,
          status: STATUSES.ERROR,
        },
      };

    // fetch stories
    case `${t.FETCH_ES_SEARCH_STORIES}_PENDING`:
      return {
        ...state,
        searchStories: {
          ...state.searchStories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_ES_SEARCH_STORIES}_SUCCESS`:
      return {
        ...state,
        searchedQuery: action.meta.q,
        searchStories: {
          ...state.searchStories,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            count: state.searchStories.pagination.count,
            items: state.searchStories.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_ES_SEARCH_STORIES}_ERROR`:
      return {
        ...state,
        searchStories: {
          ...state.searchStories,
          status: STATUSES.ERROR,
        },
      };

    case `${t.FETCH_ES_SEARCH_TAGS}_PENDING`:
      return {
        ...state,
        searchTags: {
          ...state.searchTags,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_ES_SEARCH_TAGS}_SUCCESS`:
      return {
        ...state,
        searchedQuery: action.meta.q,
        searchTags: {
          ...state.searchTags,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            count: state.searchTags.pagination.count,
            items: state.searchTags.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_ES_SEARCH_TAGS}_ERROR`:
      return {
        ...state,
        searchTags: {
          ...state.searchTags,
          status: STATUSES.ERROR,
        },
      };

    case `${t.FETCH_ES_SEARCH_USERS}_PENDING`:
      return {
        ...state,
        searchUsers: {
          ...state.searchUsers,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_ES_SEARCH_USERS}_SUCCESS`:
      return {
        ...state,
        searchedQuery: action.meta.q,
        searchUsers: {
          ...state.searchUsers,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            count: state.searchUsers.pagination.count,
            items: state.searchUsers.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_ES_SEARCH_USERS}_ERROR`:
      return {
        ...state,
        searchUsers: {
          ...state.searchUsers,
          status: STATUSES.ERROR,
        },
      };

    case t.SET_SEARCHED_QUERY:
      return {
        ...state,
        searchedQuery: action.q,
      };

    case `${t.FETCH_TAG_RANKING}_PENDING`:
      return {
        ...state,
        tagRanking: {
          ...state.tagRanking,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_TAG_RANKING}_SUCCESS`:
      return {
        ...state,
        tagRanking: {
          ...state.tagRanking,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };
    case `${t.FETCH_TAG_RANKING}_ERROR`:
      return {
        ...state,
        tagRanking: {
          ...state.tagRanking,
          status: STATUSES.ERROR,
        },
      };

    case `${t.FETCH_POPULAR_TAGS}_PENDING`:
      return {
        ...state,
        popularTags: {
          ...state.popularTags,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_POPULAR_TAGS}_SUCCESS`:
      return {
        ...state,
        popularTags: {
          ...state.popularTags,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: convertListToPagination(action.payload.result),
        },
      };
    case `${t.FETCH_POPULAR_TAGS}_ERROR`:
      return {
        ...state,
        popularTags: {
          ...state.popularTags,
          status: STATUSES.ERROR,
        },
      };

    // fetch recommendations
    case `${t.FETCH_RECOMMENDATIONS_V2}_PENDING`:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_RECOMMENDATIONS_V2}_SUCCESS`:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.recommendations.pagination.items.concat(
              action.payload.result.items
            ),
          },
          headers: action.payload.headers,
        },
      };
    case `${t.FETCH_RECOMMENDATIONS_V2}_ERROR`:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          status: STATUSES.ERROR,
        },
      };

    case `${t.SAVE_WATCH_LATER}_SUCCESS`:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          pagination: {
            ...state.recommendations.pagination,
            items: state.recommendations.pagination.items.map((item) => {
              if (item.id === action.meta.storyId) {
                return {
                  ...item,
                  isWatchLater: true,
                };
              }
              return item;
            }),
          },
        },
      };

    case `${t.DELETE_WATCH_LATER}_SUCCESS`:
      return {
        ...state,
        recommendations: {
          ...state.recommendations,
          pagination: {
            ...state.recommendations.pagination,
            items: state.recommendations.pagination.items.map((item) => {
              if (item.id === action.meta.storyId) {
                return {
                  ...item,
                  isWatchLater: false,
                };
              }
              return item;
            }),
          },
        },
      };

    case t.RESET_ALL:
      return {
        ...state,
        searchedQuery: null,
        searchStories: makeOffesetPaginationState(),
        searchTags: makeOffesetPaginationState(),
        searchUsers: makeOffesetPaginationState(),
      };

    case t.RESET_RECOMMENDATIONS:
      return {
        ...state,
        recommendations: makeOffesetPaginationState(),
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/search/reducer.js